import React from 'react';
import DatePicker, { DatePickerProps } from '../components/DatePicker';
import Error from './FormItemError';
import { useField, useFormikContext } from 'formik';
import Label from '../components/Label';
import moment from 'moment';
import FieldProps from './FieldProps';

type FormikDatePickerProps = FieldProps & {
  defaultValue?: any;
  value?: any;
  disabledDate?: any;
  format?: any;
  disabled?: any;
};
type Props = DatePickerProps &
  FieldProps & {
    noStyles?: boolean;
  };
const FormikDatePickerField: React.FC<Props> = ({
  name,
  id,
  label,
  format,
  placeholder,
  disabled,
  disabledDate,
  defaultValue,
  allowClear,
}) => {
  const [field, meta, helpers] = useField({ ...{ name, id } });
  const context = useFormikContext();
  const showError = meta.touched && meta.error;
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>;

  const onDateChange = (date: moment.Moment | null, dateString: string) => {
    context.setFieldValue(name, moment.utc(dateString));
  };

  const onBlur = (): void => {
    context.setFieldTouched(name);
  };

  return (
    <>
      <div>
        <div>
          {label && (
            <Label
              htmlFor={id || name}
              className=" formik-field__input-label no-select hand-on-hover"
            >
              {label}
            </Label>
          )}
        </div>
        <div>
          <DatePicker
            {...{
              name,
              id,
              label,
              format,
              placeholder,
              disabledDate,
              defaultValue,
              disabled,
              allowClear,
            }}
            {...field}
            onChange={onDateChange}
            //className={` ${props.className} p-8`}
            onBlur={onBlur}
          />
        </div>
        <div className="mb-16 mt-8">{error}&nbsp;</div>
      </div>
    </>
  );
};

export default FormikDatePickerField;
